// extracted by mini-css-extract-plugin
export default {"poster-background":"PosterPage_poster-background__VGwJv","stage-container":"PosterPage_stage-container__oOUWF"};